<script setup>
import {useUsersStore} from '@/stores'
const usersStore = useUsersStore()
let myUser = null
let isShowingLoadingOverlay = null;
({ myUser, isShowingLoadingOverlay } = storeToRefs(usersStore))
</script>

<template>
  <VOverlay
    v-model="isShowingLoadingOverlay"
    class="loader-overlay"
    persistent
  >
    <VProgressCircular indeterminate />
  </VOverlay>
</template>


<style lang="scss" scoped>
.loader-overlay{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
